import DefaultAdvanceWorkProgress from "src/components/feature/AdvanceWorkProgress";

const AdvanceWorkProgress = () => {
  return <DefaultAdvanceWorkProgress />;
};

export default AdvanceWorkProgress;
